import React, { useState } from 'react';
import { HoefelmeyerLogo, MinebeaLogo } from './LogoLockup';
import { ImpressumModal } from './ImpressumModal';
import { DatenschutzModal } from './DatenschutzModal';
export function FooterPanel() {
  const [impressumOpen, setImpressumOpen] = useState(false);
  const [datenschutzOpen, setDatenschutzOpen] = useState(false);
  return <footer className="w-full bg-petrol text-white pt-20 pb-8" data-id="element-77">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-78">
        {/* Logos */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-16 gap-8" data-id="element-79">
          <div className="flex items-center gap-8" data-id="element-80">
            <HoefelmeyerLogo data-id="element-81" />
          </div>
          <div className="text-sm font-medium tracking-widest text-hoefelmeyer-green uppercase border border-hoefelmeyer-green px-4 py-2" data-id="element-82">
            Partnership 2026
          </div>
        </div>

        {/* Contact Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16 relative" data-id="element-83">
          {/* Divider for desktop */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-px bg-hoefelmeyer-green/30 -translate-x-1/2" data-id="element-84"></div>

          {/* Höfelmeyer Contact */}
          <div className="pr-0 md:pr-12" data-id="element-85">
            <h4 className="text-xl font-bold mb-6 text-white" data-id="element-86">
              Höfelmeyer Waagen GmbH
            </h4>
            <div className="space-y-3 text-slate-400 font-light text-sm" data-id="element-87">
              <p data-id="element-88">Finienweg 14</p>
              <p data-id="element-89">49124 Georgsmarienhütte</p>
              <p data-id="element-90">Deutschland</p>
              <div className="pt-4 space-y-2" data-id="element-91">
                <p data-id="element-92">
                  <span className="text-slate-500 w-16 inline-block" data-id="element-93">Tel:</span>{' '}
                  <a href="#" className="hover:text-hoefelmeyer-green transition-colors" data-id="element-94">
                    +49 5401 4977-0
                  </a>
                </p>
                <p data-id="element-95">
                  <span className="text-slate-500 w-16 inline-block" data-id="element-96">
                    Email:
                  </span>{' '}
                  <a href="#" className="hover:text-hoefelmeyer-green transition-colors" data-id="element-97">
                    info@hoefelmeyer.de
                  </a>
                </p>
                <p data-id="element-98">
                  <span className="text-slate-500 w-16 inline-block" data-id="element-99">Web:</span>{' '}
                  <a href="#" className="hover:text-hoefelmeyer-green transition-colors" data-id="element-100">
                    www.hoefelmeyer.de
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Minebea Intec Contact */}
          <div className="pl-0 md:pl-12" data-id="element-101">
            <h4 className="text-xl font-bold mb-6 text-white" data-id="element-102">
              Minebea Intec GmbH
            </h4>
            <div className="space-y-3 text-slate-400 font-light text-sm" data-id="element-103">
              <p data-id="element-104">Bovenden</p>
              <p data-id="element-105">37120 Bovenden</p>
              <p data-id="element-106">Deutschland</p>
              <div className="pt-4 space-y-2" data-id="element-107">
                <p data-id="element-108">
                  <span className="text-slate-500 w-16 inline-block" data-id="element-109">Tel:</span>{' '}
                  <a href="#" className="hover:text-hoefelmeyer-green transition-colors" data-id="element-110">
                    +49 551 309-0
                  </a>
                </p>
                <p data-id="element-111">
                  <span className="text-slate-500 w-16 inline-block" data-id="element-112">
                    Email:
                  </span>{' '}
                  <a href="#" className="hover:text-hoefelmeyer-green transition-colors" data-id="element-113">
                    info@minebea-intec.com
                  </a>
                </p>
                <p data-id="element-114">
                  <span className="text-slate-500 w-16 inline-block" data-id="element-115">Web:</span>{' '}
                  <a href="#" className="hover:text-hoefelmeyer-green transition-colors" data-id="element-116">
                    www.minebea-intec.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500 font-light" data-id="element-117">
          <p data-id="element-118">© 2026 Höfelmeyer Waagen GmbH. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-119">
            <button type="button" onClick={() => setImpressumOpen(true)} className="hover:text-white transition-colors" data-id="element-120">
              Impressum
            </button>
            <button type="button" onClick={() => setDatenschutzOpen(true)} className="hover:text-white transition-colors" data-id="element-121">
              Datenschutz
            </button>
            <a href="#" className="hover:text-white transition-colors" data-id="element-122">
              AGB
            </a>
          </div>
        </div>
      </div>
      <ImpressumModal open={impressumOpen} onClose={() => setImpressumOpen(false)} data-id="element-123" />
      <DatenschutzModal open={datenschutzOpen} onClose={() => setDatenschutzOpen(false)} data-id="element-124" />
    </footer>;
}